import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";

const ACTION_LABELS = {
  login: "Signed in",
  register: "Registered",
  user_created: "User created",
  product_created: "Product created",
  product_updated: "Product updated",
  product_discontinued: "Product discontinued",
  order_status: "Order status changed",
  delivery_confirmed: "Delivery confirmed (code)",
  outstanding_updated: "Outstanding items updated",
  settings_updated: "Settings changed",
  catalogue_import: "Catalogue imported",
};

export default function AdminActivity() {
  const [logs, setLogs] = useState(null);
  const [actor, setActor] = useState("");

  const load = (a = actor) => {
    api.get("/admin/activity", { params: a ? { actor: a } : {} })
      .then((r) => setLogs(r.data.logs))
      .catch((e) => { toast.error(errMsg(e)); setLogs([]); });
  };

  useEffect(() => { load(""); /* eslint-disable-next-line react-hooks/exhaustive-deps */ }, []);

  const actors = [...new Set((logs || []).map((l) => l.actor))];

  return (
    <div data-testid="admin-activity">
      <div className="flex items-center justify-between gap-3 flex-wrap mb-6">
        <div>
          <h1 className="font-display text-2xl font-bold tracking-tight text-navy">Activity log</h1>
          <p className="text-xs text-slate-400 mt-1">Every sign-in and change made by every user — newest first.</p>
        </div>
        <select
          value={actor}
          onChange={(e) => { setActor(e.target.value); load(e.target.value); }}
          className="h-10 rounded-full border border-slate-200 px-4 text-sm bg-white outline-none focus:ring-2 focus:ring-gold"
          data-testid="activity-actor-filter"
        >
          <option value="">All users</option>
          {actors.map((a) => <option key={a} value={a}>{a}</option>)}
        </select>
      </div>

      {!logs ? (
        <div className="h-32 bg-white rounded-2xl border border-slate-100 animate-pulse" />
      ) : logs.length === 0 ? (
        <p className="bg-white rounded-2xl border border-slate-200/80 p-10 text-center text-sm text-slate-500" data-testid="activity-empty">
          No activity recorded yet.
        </p>
      ) : (
        <div className="bg-white rounded-2xl border border-slate-200/80 overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full text-sm min-w-[560px]" data-testid="activity-table">
              <thead>
                <tr className="bg-cream text-left text-[10px] uppercase tracking-[0.15em] text-slate-500">
                  <th className="px-5 py-3">When</th>
                  <th className="px-5 py-3">User</th>
                  <th className="px-5 py-3">Action</th>
                  <th className="px-5 py-3">Details</th>
                </tr>
              </thead>
              <tbody>
                {logs.map((l) => (
                  <tr key={l.id} className="border-t border-slate-100" data-testid={`activity-row-${l.id}`}>
                    <td className="px-5 py-3 text-xs text-slate-500 whitespace-nowrap">
                      {new Date(l.at).toLocaleString("en-ZA")}
                    </td>
                    <td className="px-5 py-3 font-mono text-xs">{l.actor}</td>
                    <td className="px-5 py-3">
                      <span className="text-[10px] font-bold px-2.5 py-1 rounded-full bg-navy/5 text-navy whitespace-nowrap">
                        {ACTION_LABELS[l.action] || l.action}
                      </span>
                    </td>
                    <td className="px-5 py-3 text-xs text-slate-500">{l.detail}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
}
